module.exports = __webpack_public_path__ + "img/404@2x.b1a224d9.png";